import theme from '../../../theme/news12'

import css from 'styled-jsx/css'

export default css.div`
  .wtw-wrapper {
    display: flex;
    flex-direction: column;
    justifyContent: space-between;
    flexWrap: wrap;
    margin: 30px 0;
  }

  .platforms-container {
    display: flex;
    flex-wrap: wrap;
    grid-gap: 24px;
    grid-template-columns: repeat(auto-fit, 82px);
    max-width: 100%;
    margin: auto;
    justify-content: center;
  }

  .platform {
    display: flex;
    justify-content: center;
    align-items: center; 
    cursor: pointer;
    width: 75px;
    height: 75px;
    border-radius: 100px;
    border: 1px solid ${theme.colors.lightGray3};
    overflow: hidden;
  }
  
  .platform img {
    margin: auto;
  }
`
